(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["jason-webmap"] = factory();
	else
		root["jason-webmap"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 